<div class="dropdown__wrapper">
    <div class="dropdown-label">{{ label }}</div>
    <div class="dropdown">
        <input
            [(ngModel)]="keyword"
            (ngModelChange)="searchKeyword($event)"
            (focus)="startTyping()"
            placeholder="Search"
            (keyup.enter)="selectOption(keyword)"
        />
        <div
            class="search-dropdown-icon"
            [ngClass]="{
                typing: keyword !== '',
                search: keyword === ''
            }"
            (click)="keyword !== '' ? remove() : ''"
        ></div>
    </div>
</div>
<div
    class="dropdown-option"
    *ngIf="isDropDownOpen && filteredOptions.length !== 0"
    [@fadeInOut]
    #searchDropdownOption
>
    <ul>
        <li
            *ngFor="let item of filteredOptions; let index = index"
            (click)="selectOption(item.value)"
        >
            {{ item.label }}
        </li>
    </ul>
</div>
